import { useMemo } from 'react';
import { Flame } from 'lucide-react';
import type { PulseRow } from '@/lib/pulse/api';
import { Badge } from '@/components/ui/badge';

export function StreakBadge({ pulses }: { pulses: PulseRow[] }) {
  const streak = useMemo(() => {
    if (!pulses.length) return 0;
    const days = new Set(pulses.map((p) => p.created_day));
    let count = 0;
    const cursor = new Date();
    cursor.setUTCHours(0, 0, 0, 0);
    while (days.has(cursor.toISOString().slice(0, 10))) {
      count += 1;
      cursor.setUTCDate(cursor.getUTCDate() - 1);
    }
    return count;
  }, [pulses]);

  if (streak === 0) return null;

  return (
    <Badge variant="secondary" className="gap-1">
      <Flame className="h-3 w-3" />
      {streak}-day streak
    </Badge>
  );
}
